import React from 'react'

import * as Sentry from '@sentry/react'

import ErrorPage from './ErrorPage'
import { isChunkLoadError, reloadOnceForStaleChunk } from './staleChunk'

type ErrorBoundaryWrapperProps = {
  children: React.ReactNode
}

const onError = (error: unknown) => {
  if (isChunkLoadError(error)) {
    reloadOnceForStaleChunk()
  }
}

const ErrorBoundaryWrapper: React.FC<ErrorBoundaryWrapperProps> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorPage />} onError={onError}>
      {children}
    </Sentry.ErrorBoundary>
  )
}

export default ErrorBoundaryWrapper
